const invert = require('lodash/invert');

const skus = {
  LMN: 'lmn',
  TJH: 'tjh',
  KOY: 'kingdom-of-you',
  TBT: 'birthday-thief',
  MGT: 'my-golden-ticket',
  TLB: 'littlest-bear',
  SCS: 'snowflake',
  MLM: 'little-monsters',
  TWR: 'wondrous-road',
  TPW: 'power-within',
  WAY: 'where-are-you',
  FMF: 'found-my-friends',
  MMK: 'magboggle-mystery',
  MSV: 'my-voice',
  ESC: 'elf-who-saved-christmas',
  WAB: 'where-are-you-activity-book',
  BFN: 'bedtime-for-name',
  WKN: 'what-kind-of-name',
  HBY: 'happy-birthday-to-you',
  TMC: 'thats-my-cake',
  DTD: 'dared-to-dream',
  YAE: 'you-are-extraordinary',
  WA2: 'where-are-you-2',
  DRT: 'dream-town',
  WWA: 'wonderbly-activity',
  CWY: 'christmas-wishes',
  ILY: 'i-love-you-this-much',
  ILYV1: 'i-love-you-this-much',
  IL2: 'i-love-you-this-much-v2',
  DLY: 'you-love-daddy-this-much',
  DL2: 'you-love-daddy-this-much-v2',
  GL2: 'you-love-grandma-this-much-v2',
  GD2: 'you-love-grandad-this-much-v2',
  MLY: 'you-love-mummy-this-much',
  ML2: 'you-love-mummy-this-much-v2',
  YLT: 'you-love-them-this-much',
  YL2: 'you-love-them-this-much-v2',
  YFY: 'y-is-for-you',
  DFY: 'daycare-for-you',
  WCY: 'who-can-you-can',
  BED: 'best-dad-ever',
  BEM: 'best-mum-ever',
  BEB: 'best-ever',
  TLY: 'ten-little-yous',
  YAB: 'you-and-the-beanstalk',
  AYB: 'activity-book',
  CAB: 'coloring-activity-book',
  CGB: 'coloring-book',
  YBP: 'your-birthday-party',
  YCB: 'your-colors',
  NSB: 'new-sibling-for-you',
  RRB: 'remarkable-rebels',
  ILC: 'i-love-you-more-than-christmas',
  ILCM: 'you-love-mummy-more-than-christmas',
  ILCD: 'you-love-daddy-more-than-christmas',
  ILCGM: 'you-love-grandma-more-than-christmas',
  ILCGP: 'you-love-grandad-more-than-christmas',
  ILCT: 'you-love-them-more-than-christmas',
  WAYPB: 'where-are-you-puzzle-adventure',
  BWE: 'best-wife-ever',
  BHE: 'best-husband-ever',
};

const slugs = {
  LMN: 'lost-my-name-book',
  TJH: 'the-journey-home-book',
  KOY: 'kingdom-of-you-book',
  TBT: 'the-birthday-thief-book',
  MGT: 'roald-dahl-my-golden-ticket-book',
  TLB: 'the-littlest-bear-book',
  SCS: 'the-christmas-snowflake-book',
  MLM: 'my-little-monster-name-book',
  TWR: 'the-wondrous-road-book',
  TPW: 'the-power-within-book',
  WAY: 'where-are-you-book',
  FMF: 'found-my-friends-book',
  MMK: 'the-curious-case-of-the-magboggle-mystery-kit',
  MSV: 'my-voice-book',
  ESC: 'elf-who-saved-christmas-book',
  WAB: 'where-are-you-activity-book',
  BFN: 'bedtime-for-name-book',
  WKN: 'what-kind-of-name-book',
  HBY: 'happy-birthday-to-you-book',
  TMC: 'thats-my-cake-book',
  DTD: 'dared-to-dream-book',
  YAE: 'you-are-extraordinary-book',
  WA2: 'where-are-you-2-book',
  DRT: 'dream-town-sticker-book',
  WWA: 'the-world-of-wonderbly-activity-book',
  CWY: 'christmas-wishes-book',
  ILYV1: 'i-love-you-this-much-book-v1',
  ILY: 'i-love-you-this-much-book',
  IL2: 'i-love-you-book',
  GL2: 'you-love-grandma-book',
  GD2: 'you-love-grandad-book',
  DLY: 'you-love-daddy-this-much-book',
  DL2: 'you-love-daddy-book',
  MLY: 'you-love-mummy-this-much-book',
  ML2: 'you-love-mummy-book',
  YLT: 'you-love-them-this-much-book',
  YL2: 'you-love-them-book',
  YFY: 'abc-for-you-book',
  DFY: 'daycare-for-you-book',
  WCY: 'who-can-you-can-book',
  BED: 'best-dad-ever-book',
  BEM: 'best-mum-ever-book',
  BEB: 'best-ever-book',
  TLY: 'ten-little-yous-book',
  YAB: 'jack-and-the-beanstalk-book',
  AYB: 'activity-book',
  CAB: 'coloring-activity-book',
  CGB: 'coloring-book',
  YBP: 'your-birthday-party-book',
  YCB: 'your-colors-book',
  NSB: 'new-sibling-for-you-book',
  RRB: 'remarkable-rebels-book',
  ILC: 'i-love-you-more-than-christmas-book',
  ILCM: 'you-love-mummy-more-than-christmas-book',
  ILCD: 'you-love-daddy-more-than-christmas-book',
  ILCGM: 'you-love-grandma-more-than-christmas-book',
  ILCGP: 'you-love-grandad-more-than-christmas-book',
  ILCT: 'you-love-them-more-than-christmas-book',
  WAYPB: 'where-are-you-epic-puzzle-quest-book',
  BWE: 'best-wife-ever-book',
  BHE: 'best-husband-ever-book',
};


const museEndpoints = {
  ...skus,
  // Overrides for when we want to use same muse endpoint for multiple skus
  BED: 'best-ever',
  BEM: 'best-ever',
  IL2: 'i-love-you-this-much-v2',
  ML2: 'i-love-you-this-much-v2',
  DL2: 'i-love-you-this-much-v2',
  GL2: 'i-love-you-this-much-v2',
  GD2: 'i-love-you-this-much-v2',
  ILC: 'i-love-you-more-than-christmas',
  ILCM: 'i-love-you-more-than-christmas',
  ILCD: 'i-love-you-more-than-christmas',
  ILCGM: 'i-love-you-more-than-christmas',
  ILCGP: 'i-love-you-more-than-christmas',
  ILCT: 'i-love-you-more-than-christmas',
};
// Used to calculate ratio in the book previews
const dimensions = {
  LMN: {
    width: 1280,
    height: 923,
  },
  TJH: {
    width: 1280,
    height: 906,
  },
  KOY: {
    width: 1280,
    height: 905,
  },
  TBT: {
    width: 1280,
    height: 906,
  },
  TLB: {
    width: 1280,
    height: 768,
  },
  SCS: {
    width: 1280,
    height: 768,
  },
  MLM: {
    width: 1280,
    height: 1280,
  },
  TWR: {
    width: 1280,
    height: 905.33,
  },
  FMF: {
    width: 1280,
    height: 906,
  },
  MGT: {
    width: 896,
    height: 1218,
  },
  TPW: {
    width: 896,
    height: 1218,
  },
  WAY: {
    width: 1227,
    height: 1575,
  },
  ESC: {
    width: 1280,
    height: 906,
  },
  BFN: {
    width: 1280,
    height: 1280
  },
  WKN: {
    width: 1280,
    height: 1280
  },
  HBY: {
    width: 1280,
    height: 1280
  },
  TMC: {
    width: 1280,
    height: 906,
  },
  DTD: {
    width: 1280,
    height: 906,
  },
  YAE: {
    width: 896,
    height: 1218,
  },
  DRT: {
    width: 896,
    height: 1218,
  },
  WA2: {
    width: 1227,
    height: 1575,
  },
  CWY: {
    width: 1280,
    height: 906,
  },
  ILY: {
    width: 1280,
    height: 1280,
  },
  ILYV1: {
    width: 1280,
    height: 1280,
  },
  DLY: {
    width: 1280,
    height: 1280,
  },
  MLY: {
    width: 1280,
    height: 1280,
  },
  YLT: {
    width: 1280,
    height: 1280,
  },
  YFY: {
    width: 1280,
    height: 1280
  },
  DFY: {
    width: 1280,
    height: 1280
  },
  WCY: {
    width: 1280,
    height: 1280
  },
  BED: {
    width: 896,
    height: 1218,
  },
  BEM: {
    width: 896,
    height: 1218,
  },
  BEB: {
    width: 896,
    height: 1218,
  },
  TLY: {
    width: 1280,
    height: 1280,
  },
  YAB: {
    width: 1280,
    height: 906,
  },
  YBP: {
    width: 1280,
    height: 905,
  },
  YCB: {
    width: 1280,
    height: 1280,
  },
  NSB: {
    width: 1280,
    height: 1280,
  },
  RRB: {
    width: 896,
    height: 1218,
  },
  IL2:{
    width: 1280,
    height: 1280,
  },
  DL2:{
    width: 1280,
    height: 1280,
  },
  ML2:{
    width: 1280,
    height: 1280,
  },
  YL2:{
    width: 1280,
    height: 1280,
  },
  GL2:{
    width: 1280,
    height: 1280,
  },
  GD2:{
    width: 1280,
    height: 1280,
  },
  ILC: {
    width: 1280,
    height: 1280,
  },
  ILCM: {
    width: 1280,
    height: 1280,
  },
  ILCD: {
    width: 1280,
    height: 1280,
  },
  ILCGM: {
    width: 1280,
    height: 1280,
  },
  ILCGP: {
    width: 1280,
    height: 1280,
  },
  ILCT: {
    width: 1280,
    height: 1280,
  },
  BWE: {
    width: 896,
    height: 1218,
  },
  BHE: {
    width: 896,
    height: 1218,
  },
  WAYPB: {
    width: 1227,
    height: 1575,
  }
};

const findKeyBy = {
  sku: sku => invert(skus)[sku],
  slug: slug => invert(slugs)[slug],
};

const getProductByKey = key => ({
  sku: skus[key],
  slug: slugs[key],
  dimensions: dimensions[key]
});

const getProductBySlug = slug => {
  return getProductByKey(findKeyBy.slug(slug));
};

const getProductSlugByKey = key => {
  return slugs[key];
};

const getProductSlugBySku = sku => {
  return slugs[findKeyBy.sku(sku)];
};

module.exports = {
  skus,
  slugs,
  dimensions,
  museEndpoints,
  findKeyBy,
  getProductByKey,
  getProductBySlug,
  getProductSlugByKey,
  getProductSlugBySku,
};
